import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { nanoid } from '@reduxjs/toolkit'
import clsx from 'clsx'

const Select = ({ id, label, wrapperClassname, errorClassname, type, formError, ...restProps }) => {
  const inputId = id || nanoid()
  const inputLabel = label || ''
  const inputType = type || 'text'
  const inputError = formError || null

  return (
    <div className={wrapperClassname}>
      <label htmlFor={inputId}>{inputLabel}</label>
      <input ref={ref} type={inputType} {...restProps} id={inputId} />
      {inputError && <div className={clsx('dome-p3 dome-color-red-alert', errorClassname)}>{inputError?.message}</div>}
    </div>
  )
}

Select.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  wrapperClasses: PropTypes.arrayOf(PropTypes.string),
  formError: PropTypes.object,
}

export default Select
